'use client';
import { Button, Col, Form, message, Row } from 'antd';
import styles from './newTicket.module.scss';
import { __NewTicketFormData } from './newTicket.data';
import { useForm } from 'antd/es/form/Form';
import { MobileHeaderComp } from 'components';
import { RestAPI, useAsyncClick } from 'scripts';
import { API, PATH } from 'data';
import { useNavigate } from 'react-router-dom';

function NewTicketComp() {
    const [form] = useForm();
    const nav = useNavigate();

    const submitHandler = useAsyncClick((values) => {
        return new Promise((resolve) => {
            RestAPI.post(API.ticket.create, values)
                .then(() => {
                    resolve(true);
                    nav(-1);
                })
                .catch(() => {
                    message.error('عملیات با خطا مواجه شد. لطفا بعدا تلاش کنید.');
                    resolve(true);
                });
        });
    });

    return (
        <div className={`${styles['new-ticket-layout']}`}>
            <MobileHeaderComp title="پشتیبانی تیک سبز" backPath={PATH.panel.tickets.index()} />
            <Form form={form} layout="vertical" requiredMark={false} onFinish={submitHandler.onClick}>
                <Row gutter={24}>
                    {__NewTicketFormData.map((item, index) => (
                        <Col
                            key={index}
                            lg={{ span: item.span ?? 12 }}
                            md={{ span: item.span ?? 12 }}
                            xs={{ span: 24 }}
                        >
                            <Form.Item
                                name={item.name}
                                label={<p className="t-h3 t-400 t-l-black1">{item.label}</p>}
                                rules={item.rules}
                                className={item.className}
                            >
                                {item.children}
                            </Form.Item>
                        </Col>
                    ))}
                    <Col lg={{ span: 12 }} md={{ span: 12 }} xs={{ span: 24 }}>
                        <Button
                            htmlType="submit"
                            className={`${styles['submit-btn']} w-100`}
                            loading={submitHandler.loading}
                        >
                            ثبت تیکت
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default NewTicketComp;
